import { Link } from 'react-router-dom';

const variants = {
  primary:
    'bg-gradient-to-r from-primary to-secondary text-white shadow-lg shadow-purple-500/30 hover:opacity-90',
  secondary:
    'bg-white/10 backdrop-blur-sm border border-purple-500/30 hover:bg-white/20',
  outline:
    'border border-secondary/50 text-secondary hover:bg-secondary/10',
  ghost: 'text-secondary hover:bg-white/5',
};

const sizes = {
  sm: 'px-4 py-2 text-sm',
  md: 'px-6 py-2.5 text-sm',
  lg: 'px-8 py-3 text-base',
};

export function CTAButton({
  to,
  href,
  children,
  variant = 'primary',
  size = 'md',
  icon,
  className = '',
  onClick,
  type = 'button',
}) {
  const classes = `inline-flex justify-center items-center rounded-full font-medium transition-all duration-300 ${variants[variant]} ${sizes[size]} ${className}`;

  const content = (
    <>
      {icon && <i className={`fa ${icon} mr-2`} />}
      {children}
    </>
  );

  if (href) {
    return (
      <a href={href} className={classes} onClick={onClick}>
        {content}
      </a>
    );
  }

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return (
    <button type={type} className={classes} onClick={onClick}>
      {content}
    </button>
  );
}
